export default __webpack_public_path__ + "static/media/default-bg.66db5cc5.png";